import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { useOrgLocationTree } from './hooks/use-org-location-tree';
import { TreeChecklistDropdown, TreeChecklistDropdownProps } from './tree-checklist-dropdown/tree-checklist-dropdown';
import { TreeLevelStyle } from './tree-checklist-dropdown/tree-checklist.types';

export type OrgLocationPickerProps = {
  isRequired?: boolean;
  label?: string;
  /** When provided, restrict the tree to these location ids instead of the full org. */
  locationIds?: string[];
  onChange: (locationIds: string[]) => void;
  permission: Permission;
  readOnly?: boolean;
  showApplyButton?: boolean;
  styles?: TreeChecklistDropdownProps['styles'];
  trackingIdPrefix: string;
  value: string[];
  /** Fixed field width. Pass a narrow value (e.g. 200) to render the compact variant. */
  width?: number | string;
};

const LEVEL_STYLES: TreeLevelStyle[] = [
  { indent: 16, textColor: theme.colorsV2.black(75), showCount: true, showConnector: false },
  { indent: 16, textColor: theme.colorsV2.black(60), showCount: false, showConnector: true },
];

export const OrgLocationPicker = ({
  isRequired = true,
  label,
  locationIds,
  onChange,
  permission,
  readOnly = false,
  showApplyButton = false,
  styles,
  trackingIdPrefix,
  value,
  width,
}: OrgLocationPickerProps) => {
  const { t } = useTranslation('messages');
  const { nodes, isLoading, isError } = useOrgLocationTree({ permission, locationIds });

  return (
    <TreeChecklistDropdown
      label={label ?? t('Select Locations')}
      nodes={nodes}
      value={value}
      onChange={onChange}
      levelStyles={LEVEL_STYLES}
      collapsedLabel={(selectedCount) => t('{{number}} Locations', { number: selectedCount })}
      isRequired={isRequired}
      readOnly={readOnly}
      isLoading={isLoading}
      isError={isError}
      showApplyButton={showApplyButton}
      styles={styles}
      trackingIdPrefix={trackingIdPrefix}
      width={width}
    />
  );
};
